export default __webpack_public_path__ + "static/media/Dash.6e516fb1.svg";